import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9067155c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9067155c",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WHtml from '@/components/WHtml.vue'
import WMercadoPago from '@/components/WMercadoPago.vue'
import WSwitch from '@/components/WSwitch.vue'
import WTopBar from '@/components/WTopBar.vue'
import WWysiwyg from '@/components/WWysiwyg.vue'
autoInstallComponents(component, {WHtml,WMercadoPago,WSwitch,WTopBar,WWysiwyg})
